export const MATRIX_DATA: (string|number)[][] = [
  ["",'stage_2','stage_3','stage_4','stage_5','stage_6','stage_7','stage_8'],
    ["org_6",1,0,0,0,0,0,0],
    ["org_7",1,0,1,0,0,0,0],
    ["org_28",0,1,1,0,0,0,0],
    ["org_8",0,1,1,0,0,0,0],
    ["org_10",0,0,1,0,0,0,0],
    ["org_9",0,0,0,0,1,0,0],
    ["org_33",0,0,0,1,0,0,0],
    ["org_34",0,0,0,1,0,0,0],
    ["org_27",0,0,0,1,0,0,0],
    ["org_12",0,0,0,0,0,1,0],
    ["org_13",0,0,0,0,0,1,0],
    ["org_14",0,0,0,0,0,1,0],
    ["org_15",0,0,0,0,0,1,0],
    ["org_16",0,0,0,0,0,1,0],
    ["org_17",0,0,0,0,0,1,0],
    ["org_18",0,0,0,0,0,1,0],
    ["org_20",0,0,0,0,0,1,1],
    ["org_22",0,0,0,0,0,0,1]
  ]




export const interStageData = [
  // ["org_7-stage_1","org_22-stage_3","org_22-stage_8"],
  // ["org_7-stage_2","org_22-stage_4","org_22-stage_8"],
  // ["org_22-stage_4","org_22-stage_8"],
  // ["org_10-stage_4","org_10-stage_5","org_9-stage_6"],
  // ["org_7-stage_2","org_10-stage_3","org_7-stage_4"]
]


export const connectinDotsVerticalPos = {
  1: 48,
  2: 30,
  3: 103, //95
  4: 145,
  5: 240,
  6: 385,
  7: 528,
  8: 170,
  9: 170,
  10: 170,
}

